export class ConfigurationSettingsDto
{
    private enable: boolean;
    private attribute: string;
    private description: string;

    getEnable(): boolean{
        return this.enable;
    }

    getAttribute(): string{
        return this.attribute;
    }

    getDescription(): string{
        return this.description;
    }

    fromJSON(data: any): ConfigurationSettingsDto
    {
        this.enable = data.enable;
        this.attribute = data.attribute;
        this.description = data.description;

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/configurationsettings/configurationsettingsdto.ts